import { Component, OnInit } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { OAuthService } from 'angular-oauth2-oidc';

import { Utils } from './shared/utils/utils';
import {Store} from "@ngrx/store";
import {loadEntityConfig} from "./core/state/actions/entity-config.action";
import {loadChatHubProviders} from "./core/state/actions/flow.action";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  // tslint:disable-next-line:use-host-property-decorator
})
export class AppComponent implements OnInit {
  constructor(
    private dragulaService: DragulaService,
    private oauthService: OAuthService,
    private utils: Utils,
    private store: Store
  ) {
    this.dragulaService.createGroup('first-bag', {
      moves: (el, container, handle) => {
        return handle.className === 'material-icons';
      },
    });
  }

  isLoggedIn = false;

  ngOnInit(): void {
    if (!this.oauthService.hasValidAccessToken()) {
      this.oauthService.initCodeFlow();
    } else {
      this.utils.getUserInfo();
      this.isLoggedIn = true;
      console.log('Root component loaded');
    }
    this.store.dispatch(loadEntityConfig());
  }
}
